// `topRelatesTo` connection + node types derived from the shared `IssueSecondaryNode` (regenerated by `npm run sync`).
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'

import type {IssueSecondaryNode} from '../../issue-viewer-secondary-query-types'

export const RELATES_TO_CONNECTION_PATH = ['topRelatesTo']

// RELAY-CLEANUP(RelationshipsSectionQuery): `RelayCompat` widens nullable fields for still-Relay documents.
export type RelatesToConnection = RelayCompat<IssueSecondaryNode['topRelatesTo']>
export type RelatesToIssueNode = NonNullable<NonNullable<RelatesToConnection['nodes']>[number]>
